import { ApiService } from './../../services/api/api.service';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router, RouterEvent } from '@angular/router';
import * as moment from 'moment';


@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit {
  p: number = 1;
  s3_url = environment.s3_bucket_url;
  collection: any = [];
  itemsPerPage: number = environment.items_per_page;
  totalItems = 0;
  moment = moment;
  constructor(
    private apiService: ApiService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  ionViewWillEnter(){
    this.getNotifications();
  }

  getNotifications(){
    this.apiService.get(`user-notifications/${this.p}`).subscribe((res) => {
      this.totalItems = res.count;
      this.collection = res.data;
      console.log("collection", this.collection);
    });
  }

  pageChangeEvent(event: number){
    this.p = event;
    this.getNotifications();
  }

  goToProfile(account_type, id){
    let type = 'user';
    if(account_type == 1)
      type = 'band';
    else if(account_type == 2)
      type = 'comedian';
    else if(account_type == 3)
      type = 'food-truck';
    else if(account_type == 4)
      type = 'user';
    else if(account_type == 5)
      type = 'venue';
    else if(account_type == 6)
      type = 'comedy-club';
    else if(account_type == 7)
      type = 'artist';

    let userId = btoa(id);
    this.router.navigate([`${type}/${userId}`]);
  }

}
